import { motion } from 'framer-motion';

const services = [
  {
    number: '01',
    title: 'Brand Strategy',
    description: '브랜드의 핵심 가치를 발견하고 시장에서의 차별화된 포지셔닝을 구축합니다',
  },
  {
    number: '02',
    title: 'Digital Design',
    description: '사용자 경험을 최우선으로 하는 직관적이고 아름다운 디지털 인터페이스를 디자인합니다',
  },
  {
    number: '03',
    title: 'Creative Development',
    description: '최신 기술과 창의적인 아이디어를 결합하여 혁신적인 디지털 솔루션을 개발합니다',
  },
  {
    number: '04',
    title: 'Marketing Campaign',
    description: '데이터 기반의 전략적 마케팅으로 브랜드의 성장을 가속화합니다',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 lg:py-32 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 lg:mb-24"
        >
          <h2
            className="text-5xl sm:text-6xl lg:text-7xl font-light mb-6"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Services
          </h2>
          <p className="text-lg lg:text-xl text-zinc-600 font-light max-w-2xl">
            전문적인 크리에이티브 서비스
          </p>
        </motion.div>

        <div className="space-y-px bg-zinc-900">
          {services.map((service, index) => (
            <motion.div
              key={service.number}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white p-8 lg:p-12 hover:bg-zinc-50 transition-colors group cursor-pointer"
            >
              <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
                <div className="text-4xl lg:text-5xl font-light text-zinc-300 group-hover:text-zinc-900 transition-colors">
                  {service.number}
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl lg:text-3xl font-light mb-3">{service.title}</h3>
                  <p className="text-base lg:text-lg text-zinc-600 font-light leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
